import { IconInfoCircle } from '@tabler/icons-react';
import { Alert, Button, Select, Text } from '@mantine/core';
import { useMapContext } from '@/contexts/MapContext';
import { SimulationPlayer } from './SimulationPlayer';
import styles from './networksimulation.module.css';

export const NetworkSimulation = () => {
  const {
    simulationSelection,
    isOptimalMode,
    isOptimalModeLoaded,
    exitOptimalMode,
    setSimulationSelection,
    findOptimalLocations,
  } = useMapContext();

  const handleEventChange = (value: string | null) => {
    if (value) {
      setSimulationSelection(value);
    } else {
      setSimulationSelection(null);
    }
  };

  return (
    <div className={styles.content}>
      <Text size="sm">
        Select a historical rainfall event to visualise drainage network responses
      </Text>
      <hr className={styles.divider} />
      <Select
        placeholder="Select Event"
        defaultValue=""
        data={[
          { label: 'Enfield Overflow Event - Feb 2025', value: 'EnfieldFeb' },
          { label: 'None', value: '' },
        ]}
        required
        styles={{
          root: {
            width: '100%',
          },
        }}
        value={simulationSelection}
        onChange={handleEventChange}
      />
      {simulationSelection && <SimulationPlayer />}
      <hr className={styles.divider} />
      {!(isOptimalMode && isOptimalModeLoaded) ? (
        <>
          <Alert icon={<IconInfoCircle />}>
            {simulationSelection
              ? '‘Find Optimal Locations’ will find the optimal placement for SuDS based on the selected event'
              : 'To find optimal locations for SuDS you must have an event selected'}
          </Alert>
          <Button
            type="submit"
            variant="filled"
            className={styles.button}
            disabled={!simulationSelection}
            onClick={findOptimalLocations}
          >
            Find Optimal Locations
          </Button>
        </>
      ) : (
        <>
          <Alert icon={<IconInfoCircle />}>
            Baseline View will show the simulation without the optimised SuDS in place
          </Alert>
          <Button
            variant="default"
            onClick={exitOptimalMode}
            className={styles.headerButton}
            disabled={!isOptimalModeLoaded}
          >
            Return to Baseline View
          </Button>
        </>
      )}
      <hr className={styles.divider} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <div>
          <Text size="xs" pb={8}>
            Water Infiltration
          </Text>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div
              style={{
                width: '100%',
                height: '8px',
                background: 'linear-gradient(90deg, #e6f2da, #2b83ba)',
                borderRadius: '4px',
              }}
            />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text size="xs">Low</Text>
              <Text size="xs">High</Text>
            </div>
          </div>
        </div>
        <div>
          <Text size="xs" pb={8}>
            Rainfall (mm)
          </Text>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <div
              style={{
                width: '100%',
                height: '8px',
                background: 'linear-gradient(90deg, #e8f0d6, #ff7900)',
                borderRadius: '4px',
              }}
            />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
              <Text size="xs">Low</Text>
              <Text size="xs">High</Text>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
